import React, { useMemo } from "react";
import { useSelector } from "react-redux";
import { useTranslation } from "react-i18next";

import { CURRENCY_UNITS } from "../../constants/global.constants";
import IconWithTooltip from "../../common/styles/components/headings/IconWithTooltip";
import UtilityCostFields from "../../components/UtilityCosts/UtilityCostFields";
import ChemicalSelectionFields from "../../components/ChemicalSelectionFields";

import "./index.scss";

const CostInformation = (props) => {
  const { t } = useTranslation();
  const { disabled = false } = props;

  const { trainUtilityCosts, trainChemicalSelection, currency, volume, mass } =
    useSelector((state) => state);

  const costValues = useMemo(
    () => ({
      priceOfWater: trainUtilityCosts?.water_price || "",
      costOfElectricity: trainUtilityCosts?.energy_price || "",
      costOfDowntime: trainUtilityCosts?.downtime_cost || "",
    }),
    [trainUtilityCosts],
  );

  return (
    <div className="ro-card-wrapper position-relative cost-information-card">
      <div className="ro-card-header">
        <div className="info-section">
          <div className="teal-heading ">
            {t("costInformationStrings.constInformation")}
          </div>
          {!disabled && (
            <IconWithTooltip label={t("helpInformation.costInformationHelp")} />
          )}
        </div>
      </div>
      <div className="cost-information-sections">
        <div className="cost-information-section">
          <div className="cost-information-section-header">
            {t("costInformationStrings.chemicalCosts")}
          </div>
          <ChemicalSelectionFields
            selectedChemicals={trainChemicalSelection}
            currencyUnit={currency ? CURRENCY_UNITS[currency] : "$"}
            mass={mass}
            disabled={disabled}
            containerClassName="cost-info-chemical-costs"
          />
        </div>

        <div className="cost-information-section">
          <div className="cost-information-section-header">
            {t("costInformationStrings.utilityCosts")}
          </div>
          <UtilityCostFields
            values={costValues}
            currency={currency}
            volume={volume}
            disabled={disabled}
            containerClassName="cost-info-utility-costs"
          />
        </div>
      </div>
    </div>
  );
};

export default CostInformation;
